import Link from "next/link";

const ViewButton = props => {
    return (
        <div className="flex items-center mx-auto">
            <Link href={props.path}>
                <button
                    className="text-center border-2 border-black hover:bg-black hover:text-white font-medium font-button px-8 py-2 text-sm mx-auto md:mx-4 mt-8">
                    {props.title}
                </button>
            </Link>
        </div>
    );
};

export default ViewButton;
